<template>
  <div>
    <v-row>
      <!--      desktop view-->
      <v-col cols="12" md="5">
        <v-row>
          <v-col cols="12" class="hidden-md-and-up">
            <!--            <v-card elevation="0"-->
            <!--                    color="commission-content-holder full-height primary white&#45;&#45;text text-center pa-2 mb-3">-->
            <!--              <v-card-text>-->
            <!--                <v-row justify="center" no-gutters>-->
            <!--                  <v-col cols=9 class="mb-3">-->
            <!--                    <label class="white&#45;&#45;text">{{ $t(`label.commissionToRedeem`) }}</label>-->
            <!--                  </v-col>-->
            <!--                  <v-col cols=9 class="mb-0">-->
            <!--                    <v-form ref="redeemForm">-->
            <!--                      <app-form-field :customClass="'commission-redeem-field input-field elevation-0 hide-details'"-->
            <!--                                      :enabledLabel="false" v-model.trim="redeemCommissionAmt" :readonly='true'-->
            <!--                                      :prefix="currencySymbolMapp(currentCurrency)"-->
            <!--                                      :rules="validator.requiredRules()"></app-form-field>-->
            <!--                    </v-form>-->
            <!--                  </v-col>-->
            <!--                  <v-col cols=9>-->
            <!--                    <app-button class="dialog-button" :action="redeemCommissionConfirmationDialog"-->
            <!--                                :title="$t(`button.redeem`)"></app-button>-->
            <!--                  </v-col>-->
            <!--                </v-row>-->
            <!--              </v-card-text>-->
            <!--            </v-card>-->
            <v-card class="hidden-md-and-up mobile-balance-card">
              <div class="mobile-balance-div">
                <div>
                  <span style="color:#FFFFFF">{{ $t(`mobileMenuTitle.availableCom`) }}</span>
                  <div class="balance-span">
                    <span>{{ redeemCommissionAmt | currency(currentCurrency) }}</span>
                    <!--                    <v-form ref="redeemForm">-->
                    <!--                       <app-form-field-->
                    <!--                        :customClass="'commission-redeem-field input-field elevation-0 hide-details'"-->
                    <!--                        :enabledLabel="false"-->
                    <!--                        v-model.trim="redeemCommissionAmt"-->
                    <!--                        :readonly="true"-->
                    <!--                        :prefix="currencySymbolMapp(currentCurrency)"-->
                    <!--                        :rules="validator.requiredRules()"-->
                    <!--                      ></app-form-field>-->
                    <!--                    </v-form>-->
                  </div>
                  <div>
                    <v-btn class="dialog-button mobile-redeem-btn" @click="redeemCommissionConfirmationDialog">{{ $t(`label.claim`) }}</v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="5" sm="6" class="hidden-md-and-down">
            <v-row no-gutters align="end">
              <v-col cols="12">
                <label>{{ $t(`label.todayCommission`) }}</label>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-card color="primary white--text text-left py-2 pl-6 mb-3">
                  {{ $t(`label.points`) }}
                  {{ overview.commission_balance }}
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters align="end">
              <v-col cols="12">
                <label>{{ $t(`label.monthCommission`) }}</label>
              </v-col>
            </v-row>
            <v-row no-gutters align="start">
              <v-col cols="12">
                <v-card color="primary white--text text-left py-2 pl-6">
                  {{ $t(`label.points`) }}
                  {{ overview.commission_month }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" sm="6" class="hidden-md-and-down">
            <v-row no-gutters align="end">
              <v-col cols="6">
                <v-card elevation="0" color="border-left-radius primary white--text text-center pa-2 mb-3 mr-1">
                  {{ $t(`label.total`) }}
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card elevation="0" color="border-right-radius primary white--text text-center pa-2 mb-3 mr-1">
                  {{ totalPoint }}
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="6">
                <v-card elevation="0" color="border-left-radius title_color2 white--text text-center pa-2 mb-3 mr-1">{{ $t(`label.affiliateLevel`) }} 1</v-card>
              </v-col>
              <v-col cols="6">
                <v-card elevation="0" color="border-right-radius title_color2 white--text text-center pa-2 mb-3 mr-1">
                  {{ overview.downline_lv1 }}
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters align="end">
              <v-col cols="6">
                <v-card elevation="0" color="border-left-radius title_color2 white--text text-center pa-2 mb-3 mr-1">{{ $t(`label.affiliateLevel`) }} 2</v-card>
              </v-col>
              <v-col cols="6">
                <v-card elevation="0" color="border-right-radius title_color2 white--text text-center pa-2 mb-3 mr-1">
                  {{ overview.downline_lv2 }}
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters align="start">
              <v-col cols="6">
                <v-card elevation="0" color="border-left-radius title_color2 white--text text-center pa-2 mb-3 mr-1">{{ $t(`label.affiliateLevel`) }} 3</v-card>
              </v-col>
              <v-col cols="6">
                <v-card elevation="0" color="border-right-radius title_color2 white--text text-center pa-2 mb-3 mr-1">
                  {{ overview.downline_lv3 }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!--      desktop view-->
      <v-col cols="12" md="7" class="hidden-sm-and-down">
        <v-row no-gutters>
          <v-col cols="5">
            <v-card elevation="0" color="commission-content-holder full-height primary white--text text-center pa-2 mb-3">
              <v-card-text>
                <v-row justify="center" no-gutters>
                  <v-col cols="9" class="mb-3">
                    <label class="white--text">{{ $t(`label.commissionToRedeem`) }}</label>
                  </v-col>
                  <v-col cols="9" class="mb-0">
                    <v-form ref="redeemForm">
                      <app-form-field
                        :customClass="'commission-redeem-field input-field elevation-0 hide-details'"
                        :enabledLabel="false"
                        v-model.trim="redeemCommissionAmt"
                        :readonly="true"
                        :prefix="currencySymbolMapp(currentCurrency)"
                        :rules="validator.requiredRules()"
                      ></app-form-field>
                    </v-form>
                  </v-col>
                  <v-col cols="9">
                    <app-button class="dialog-button" :action="this.redeemCommissionConfirmationDialog" :title="$t(`button.redeem`)"></app-button>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="7" sm="7">
            <v-card elevation="0" color="commission-content-holder base pa-2 mb-3 full-height">
              <v-card-text>
                <v-row no-gutters justify="center">
                  <v-col cols="12" md="3" class="text-left">
                    <label color="primary">
                      {{ $t(`label.id`) }} :
                      <span class="font-weight-bold">{{ overview.member_id }}</span>
                    </label>
                  </v-col>
                  <v-col cols="12" md="7" lg="5" class="mb-0 text-center">
                    <label color="primary">
                      {{ $t(`field.referralCode`) }} :
                      <span class="font-weight-bold">{{ overview.my_referral_code }}</span>
                    </label>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="5" md="4" sm="5">
                    <vue-qr-code v-if="overview.my_referral_code" class="qrCode" :text="share_url" :size="105"></vue-qr-code>
                  </v-col>
                  <v-col cols="12" md="12" sm="8" class="mb-0">
                    <v-row no-gutters justify="center">
                      <v-col cols="8" lg="6">
                        <!-- <v-img class="mr-2" src="/static/svg/fb_btn.svg" @click="share()"> </v-img> -->
                        <v-btn class="full-width font-weight-bold pa-2" :class="'buttonPrimary theme-button theme--light subtitle-1'" @click="share()">
                          <v-icon class="mr-2">share</v-icon>
                          {{ webShareApiSupported ? $t(`button.shareNow`) : $t(`button.copyRef`) }}
                        </v-btn>
                      </v-col>
                      <!-- <v-col cols=6>
                          <v-img class="mr-2" src="/static/svg/whatapps_btn.svg"> </v-img>
                      </v-col> -->
                    </v-row>
                    <!-- <v-row no-gutters justify="center" class="pt-3">
                        <v-col cols=6>
                            <v-img class="mr-2" src="/static/svg/line_btn.svg"> </v-img>
                        </v-col>
                        <v-col cols=6>
                            <v-img class="mr-2" src="/static/svg/twitter_btn.svg"> </v-img>
                        </v-col>
                    </v-row> -->
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="display: flex;gap: 0px 1.5rem;justify-content: space-evenly;">
        <div class="summaryRouter-link" :class="this.$route.name.toLowerCase()==routeName.REFERRAL_SUMMARY_REPORT?'summaryRouter-link-selected':''" >
          <router-link :to="routeName.REFERRAL_SUMMARY_REPORT"  style="text-decoration: unset !important">
            <span>{{ $t(`button.referralReport`) }}</span>
          </router-link>
        </div>
        <div class="summaryRouter-link" :class="this.$route.name.toLowerCase()==routeName.REFERRAL_SUMMARY_HISTORY?'summaryRouter-link-selected':''">
          <router-link :to="routeName.REFERRAL_SUMMARY_HISTORY" style="text-decoration: unset !important">
            <span>{{ $t(`button.redeemHistory`) }}</span>
          </router-link>
        </div>
      </v-col>
      <v-col cols="12" class="refSummaryContainer">
        <router-view></router-view>
      </v-col>
    </v-row>
    <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="1000" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'check_circle' : 'cancel'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
  </div>
</template>

<script>
import VueQrCode from 'vue-qrcode-component'
import AppLoginEmbedded from '@/components/member/loginEmbedded.vue'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper, locale, errorCodeHelper, formValidator } from '@/util'
import { SHARED } from '@/constants/constants'
import _ from 'lodash'
import { REFERRAL_GET_OVERVIEW, REFERRAL_POST_COMMISSION, REFERRAL_RESET_COMMISSION } from '@/store/referral.module'
import stringFormat from 'string-format'
import currencySymbolMapp from 'currency-symbol-map'

export default {
  name: 'referralSummary',
  components: {
    VueQrCode,
    AppLoginEmbedded
  },
  data: () => ({
    dateOfBirthMenu: false,
    stringFormat: stringFormat,
    currencySymbolMapp: currencySymbolMapp,
    language: uiHelper.getLanguage(),
    currentCurrency: uiHelper.getCurrency(),
    validator: formValidator,
    shared: SHARED,
    selectedTab: 'tier',
    dates: ['', ''],
    overview: {},
    redeemCommissionAmt: 0.0,
    share_url: '',
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
    routeName: ROUTE_NAME
  }),
  created() {
    this.getReferralOverview()
    this.metaTag()
  },
  mounted() {
    this.$refs.redeemForm.reset()
  },
  computed: {
    currentDate() {
      return new Date()
    },
    referralOverview() {
      return this.$store.state.referral.overview
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    totalPoint() {
      return this.overview.downline_lv1 + this.overview.downline_lv2 + this.overview.downline_lv3
    },
    redeemCommissionDetailResponseComplete() {
      return this.$store.state.referral.redeemCommissionResponse.complete
    },
    webShareApiSupported() {
      return navigator.share
    }
  },
  watch: {
    referralOverview() {
      this.overview = this.$store.state.referral.overview
      this.share_url = uiHelper.getHostname() + '?refer_code=' + this.overview.my_referral_code
      this.redeemCommissionAmt = this.$store.state.referral.overview.commission_balance.toFixed(2)
    },
    redeemCommissionDetailResponseComplete() {
      let response = this.$store.state.referral.redeemCommissionResponse
      if (response.complete) {
        this.redeemCommissionResponseCompleteDialog(response)
        this.$store.dispatch(`${REFERRAL_RESET_COMMISSION}`)
      }
    }
  },
  methods: {
    metaTag() {
      uiHelper.setTitle(`${locale.getMessage('meta.referralSummarry_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.referralSummary_description')}`)
    },
    openMsgDialog(selectedMsg) {
      this.msgDialog = {
        show: true,
        msg: selectedMsg.message,
        title: selectedMsg.subject
      }
    },
    closeMsgDialog() {
      this.msgDialog = {
        show: false
      }
    },
    getReferralOverview() {
      if (this.isLoggedIn) this.$store.dispatch(`${REFERRAL_GET_OVERVIEW}`)
    },
    redeemCommissionConfirmationDialog() {
      let self = this
      if (this.$refs.redeemForm.validate()) {
        let dialog = this.initializePageDialogProperty()
        dialog.title = locale.getMessage(`label.redeemConfirmation`)
        dialog.message.push(this.stringFormat(locale.getMessage(`message.ConfirmCommission`), self.$options.filters.currency(this.redeemCommissionAmt, this.currentCurrency)))
        dialog.button.push({
          title: locale.getMessage(`label.confirm`),
          action: () => this.redeemCommission()
        })
        this.openPageDialog(dialog)
      }
    },
    redeemCommission() {
      let obj = { amount: this.redeemCommissionAmt }
      this.$store.dispatch(`${REFERRAL_POST_COMMISSION}`, {
        obj
      })
    },
    redeemCommissionResponseCompleteDialog(response) {
      this.closePageDialog()
      if (response.code != 0 && !response.success) {
        this.$parent.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(response.code))
      } else {
        this.$parent.$parent.openAlert(true, locale.getMessage(`message.commissionRedeemSuccess`))
      }
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$eventHub.$emit('close-page-dialog', true)
    },
    share() {
      const sharing = {
        title: 'Refer a friend now and earn commission',
        text: 'Your referral code is ' + this.overview.my_referral_code + '.Refer a friend now and earn commission now! ',
        url: this.share_url
      }
      if (this.webShareApiSupported) {
        navigator.share(sharing)
      } else {
        let $f = this
        this.$copyText(this.share_url).then(function(e) {
          $f.alertMessage = 'Referral Link Copied!'
          $f.alertSuccess = true
          $f.alertShow = true
        })
      }
    }
  }
}
</script>

<style lang="scss">
.summaryRouter-link{
  display:flex;
  min-width: 100px;
  min-height: 50px;
  align-items: center;
  justify-content: center;
  background-color: #D9D9D9;
  color:#000000;
  border-radius: 15px;
  padding:12px 16px;
}
.summaryRouter-link-selected{
  color: #ffffff;
  background-color: #333333;
}
.balance-span {
  color: #ffce01 !important;
  font-size: 1.5rem;
  margin-top: 10px;
}
.mobile-redeem-btn {
  background-color: var(--v-newMobileSecondary-base) !important;
  color: #000000 !important;
  margin-top: 10px;
  width: 150px;
  text-transform: unset !important;
}
.mobile-balance-card.v-card {
  background-color: #333333;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 135px;
  margin-left: 60px;
  margin-right: 60px;
  border-radius: 10px;
  .mobile-balance-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
.border-left-radius {
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.border-right-radius {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}

.commission-redeem-field {
  .v-input__slot {
    background-color: #fff !important;
  }
}

.media-btn {
  height: 50px;
  width: 100px;
}

.commission-content-holder {
  border-radius: 20px !important;
}

.v-btn.theme-button {
  // background: #FDDD04;
  text-transform: capitalize;
  border-radius: 10px;
  height: auto;
  font-size: 16px;
}
</style>
